import { COUNTDOWN_TARGET } from '@/config/eclipse'
import { useCountdown } from '@/hooks/useCountdown'
import { useI18n } from '@/i18n'
import { padTwo } from '@/lib/countdown'

/**
 * Primary countdown: total days, hours, minutes, seconds.
 *
 * Days is the *total* remaining day count (e.g. 316), not a remainder — the
 * months/weeks breakdown is a separate view, see `CalendarView`.
 * Two columns on phones, four in a row from `sm`.
 */
export function CountdownGrid() {
  const { t } = useI18n()
  const countdown = useCountdown(COUNTDOWN_TARGET)

  const units = [
    { key: 'days', value: countdown.totalDays, label: t.countdown.daysShort, pad: false },
    { key: 'hours', value: countdown.hours, label: t.countdown.hoursShort, pad: true },
    { key: 'minutes', value: countdown.minutes, label: t.countdown.minutesShort, pad: true },
    { key: 'seconds', value: countdown.seconds, label: t.countdown.secondsShort, pad: true },
  ]

  return (
    <div
      className="grid grid-cols-2 gap-2.5 sm:grid-cols-4 sm:gap-3 lg:gap-4"
      role="timer"
      aria-live="off"
      aria-label={t.countdown.heading}
    >
      {units.map((unit) => (
        <div
          key={unit.key}
          className="rounded-xl border border-gold/12 bg-white/[0.025] px-2 py-5 text-center backdrop-blur-sm transition duration-300 ease-[var(--ease-out-soft)] hover:border-gold/45 hover:bg-white/[0.045] sm:rounded-2xl sm:py-8"
        >
          <span className="tabular gold-text block font-serif text-[clamp(2.5rem,11vw,4.5rem)] font-bold leading-none">
            {unit.pad ? padTwo(unit.value) : Math.max(0, unit.value)}
          </span>
          <span className="mt-2.5 block text-[0.625rem] uppercase tracking-[0.22em] text-faint sm:text-xs">
            {unit.label}
          </span>
        </div>
      ))}
    </div>
  )
}
